import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import Subject from "./routes/Subject";

export default store => ({
  path: "subject-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "subject-settings" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [Subject(store)],
});
